module.exports = __webpack_public_path__ + "img/8.a371ca37.png";